export { default } from './filled-icon'
export type { FilledIconProps } from './filled-icon'
